<div class='SelectEventWizardStep p-3' *ngIf="formGroup">
  <form [formGroup]='formGroup'>
    <mat-radio-group
      aria-label='Select an event'
      class='d-flex flex-row flex-sm-column'
      formControlName='event'>
      <mat-radio-button [value]='events.ALL'
      >All events
      </mat-radio-button
      >
      <mat-radio-button [value]='events.OPENED' class='mt-0 mt-sm-3 ms-3 ms-sm-0'
      >Opened
      </mat-radio-button
      >
      <mat-radio-button [value]='events.CLICKED' class='mt-0 mt-sm-3 ms-3 ms-sm-0'
      >Clicked
      </mat-radio-button
      >
      <mat-radio-button [value]='events.DELIVERED' class='mt-0 mt-sm-3 ms-3 ms-sm-0'
      >Delivered
      </mat-radio-button
        >
        <mat-radio-button [value]='events.COMPLAINED' class='mt-0 mt-sm-3 ms-3 ms-sm-0'
        >Complained
        </mat-radio-button
        >
    </mat-radio-group>
  </form>
</div>
